import { CancelSurveyFormResult } from "@/containers/cancelSurveyForm/CancelSurveyFormResult";
import { CancelSurveyUpdateResult } from "@/containers/cancelSurveyForm/CancelSurveyUpdateResult";

type State = {
  results: { [index: number]: CancelSurveyFormResult };
  resultCount: number;
};

export default {
  namespaced: true,
  state: {
    results: {},
    resultCount: 0
  } as State,
  getters: {},
  actions: {},
  mutations: {
    updateResults(state: State, { index, result }: CancelSurveyUpdateResult) {
      let newResults = JSON.parse(JSON.stringify(state.results)); // 変更を検知させるためにオブジェクトをコピーする
      if (result === null) {
        delete newResults[index];
      } else {
        newResults[index] = result;
      }
      state.results = newResults;
      state.resultCount = Object.keys(state.results).length;
    }
  }
};
